






































































































import Vue from "vue";
import { axios } from "@/plugins";
import download from "@/utils/download";

export default Vue.extend({
  name: "PrjLogs",
  props: { projectId: { type: String } },
  data() {
    return {
      // options: [] as any[],
      searchForm: {
        // searchValue: [],
        component: "",
        pod: "",
        container: "",
        filterValue: "",
        logLinght: "",
        date: [] as Array<Date>
      },
      comOptions: [] as any[],
      podOptions: [] as any[],
      containerOptions: [] as any[],
      loading: false,
      hasSearched: false,
      logs: [],
      pages: {
        index: -1,
        size: 100,
        hasMore: true
      }
    };
  },
  computed: {
    comLogs() {
      const length = this.logs.length;
      if (length < 2000) {
        // @ts-ignore
        return this.logs;
      } else {
        // @ts-ignore
        return this.logs.slice(-2000);
      }
    }
    // containerOptions() {
    //   if (
    //     !this.searchForm.searchValue[0] &&
    //     this.searchForm.searchValue[0] !== 0
    //   )
    //     return [];
    //   // @ts-ignore
    //   return this.options[this.searchForm.searchValue[0]].children;
    // }
  },
  mounted() {
    // this.getOptions();
    this.getComponent();
    this.getPod();
  },
  methods: {
    getComponent() {
      axios.get(`/logs/${this.projectId}/component`).then(res => {
        this.comOptions = res.data.data;
      });
    },
    getPod(query = "") {
      axios
        .get(
          `/logs/${this.projectId}/pods?componentName=${this.searchForm.component}&podName=${query}`
        )
        .then(res => {
          this.podOptions = res.data.data;
        });
    },
    getContainer(query = "") {
      axios
        .get(
          `/logs/${this.projectId}/containers?componentName=${this.searchForm.component}&podName=${this.searchForm.pod}&containerName=${query}`
        )
        .then(res => {
          this.containerOptions = res.data.data;
        });
    },
    comChange() {
      this.searchForm.pod = "";
      this.searchForm.container = "";
      this.getPod();
    },
    // 组件触发容器清空
    podChange() {
      this.searchForm.container = "";
      this.getContainer();
    },
    containerChange(val: number) {
      const data = this.containerOptions.find(item => (item.containerId = val));
      if (data.startTime && data.endTime) {
        this.searchForm.date = [
          new Date(data.startTime),
          new Date(data.endTime)
        ];
      }
    },
    getLogs(clear = true) {
      if (clear) {
        this.pages.index = -1;
        this.pages.hasMore = true;
        this.logs = [];
      }
      this.loading = true;
      axios
        .get(
          `/logs/${this.projectId}/query?componentName=${
            this.searchForm.component
          }&podName=${this.searchForm.pod}&containerName=${
            this.searchForm.container
          }&queryString=${
            this.searchForm.filterValue
          }&start=${this.searchForm.date[0].getTime()}&end=${this.searchForm.date[1].getTime()}&page=${this
            .pages.index + 1}&size=${this.pages.size}`
        )
        .then(res => {
          // log 高亮
          this.searchForm.logLinght = this.searchForm.filterValue;
          this.logs = this.logs.concat(res.data.data.content);
          this.pages.index = res.data.data.pageable.page;
          if (res.data.data.content && res.data.data.content.length) {
            this.pages.hasMore = true;
          } else {
            this.pages.hasMore = false;
          }
          this.hasSearched = true;
        })
        .finally(() => {
          this.loading = false;
        });
    },
    lightCode(log: string) {
      if (!this.searchForm.logLinght) {
        return log.replace("<", "&lt;").replace(">", "&gt;");
      }
      const reg = new RegExp(this.searchForm.logLinght.trim(), "gi");
      return log
        .replace("<", "&lt;")
        .replace(">", "&gt;")
        .replace(reg, str => `<b>${str}</b>`);
    },
    download() {
      this.loading = true;
      download(
        `/logs/${this.projectId}/download?componentName=${
          this.searchForm.component
        }&podName=${this.searchForm.pod}&containerName=${
          this.searchForm.container
        }&queryString=${
          this.searchForm.filterValue
        }&start=${this.searchForm.date[0].getTime()}&end=${this.searchForm.date[1].getTime()}`,
        () => {
          this.loading = false;
        }
      );
    },
    logReload() {
      if (this.pages.hasMore) {
        this.getLogs(false);
      } else {
        this.$message.warning("没有更多日志");
      }
    }
  }
});
